// extracted by mini-css-extract-plugin
export default {"mCard":"_F-z","image":"aG-z","imageNoBackground":"bG-z","fullWidth":"cG-z"};